import React from 'react';

export enum MarkerTypes {
  User = 'user',
  UserManual = 'userManual',
  // Delivery markers
  Driver = 'driver',
  Destination = 'destination',
  DeliveryWork = 'deliveryWork',
  DeliveryLocation = 'deliveryLocation',
  // Store markers
  StoreOpen = 'storeOpen',
  StoreOpenSelected = 'storeOpenSelected',
  StoreNotAvailable = 'storeNotAvailable',
  StoreNotAvailableSelected = 'storeNotAvailableSelected',
  // Store favorite markers
  StoreFav = 'storeFav',
  StoreFavNotAvailable = 'storeFavNotAvailable',
}

export const USER_LOCATION_MARKER_TITLE = 'User location marker';

export interface IMarkerInput {
  id: string;
  type: MarkerTypes;
  location: CenterPoint;
  onPress?: () => void;
  title?: string;
  isSelected?: boolean;
  isFocused?: boolean;
  visible?: boolean;
}

export interface IMarker extends IMarkerInput {
  icon: React.ReactNode;
  preventMarkerPress: boolean;
}

export type MarkersMap = {
  [key: string]: IMarker;
};

type MapEventListener = (...args: any[]) => void;

export interface IUseMapArgs {
  initialZoomAndroid?: number;
  initialZoomIOS?: number;
  eventListeners?: {
    [key: string]: MapEventListener | Array<MapEventListener>;
  };
  position?: CenterPoint;
  disableControls?: boolean;
  isStaticMap?: boolean;
}

export type PanToFn = (
  newPosition: {
    lat?: number | null;
    lng?: number | null;
  } | null
) => Promise<void>;

export type FitAndCenterFromCoordsFn = (coordsArray: CenterPoint[]) => void;

export type CenterPoint = {
  lat: number;
  lng: number;
};

export interface ILocation extends CenterPoint {
  accuracy?: number;
}

export type IUseMapHook = (
  args?: IUseMapArgs
) => {
  center: CenterPoint;
  createMarker: (args: IMarkerInput) => void | string;
  createMarkerList?: (args: IMarkerInput[]) => void;
  clearMarkers: () => void;
  fitAndCenterFromCoords: FitAndCenterFromCoordsFn;
  map: React.ReactNode;
  panTo: PanToFn;
  updateMarkerPosition?: (markerKey: string, position: CenterPoint) => void;
  zoom: number;
};
